<template>
    <div id="tryout-group">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Konsul' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <!-- <h3 class="header-text font-weight-bold">Konsul</h3> -->
        <div>
            <v-row>
                <v-col cols="12" md="10">
                    <h3 class="header-text font-weight-bold">Konsul</h3>
                </v-col>

                <v-cols cols="12" md="2" class="align-right">
                    <div class="text-right mt-5">
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-width="120"
                            offset-x
                        >
                            <template
                                v-slot:activator="{ on, attrs }"
                                class="text-right"
                            >
                                <span style="font-size: 16px">
                                    Filter &nbsp;&nbsp;</span
                                >
                                <v-btn
                                    depressed
                                    color="white"
                                    v-bind="attrs"
                                    v-on="on"
                                    width="120"
                                >
                                    <span class="blew--text">
                                        <span v-if="filter_type === 'ALL'"
                                            >Semua</span
                                        >
                                        <span v-if="filter_type === 'CUSTOM'"
                                            >Custom</span
                                        >
                                        <v-icon color="blew" small class="ml-6">
                                            mdi-chevron-down
                                        </v-icon>
                                    </span>
                                </v-btn>
                            </template>

                            <v-card class="pt-7" width="350">
                                <v-card-title>
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <div style="font-size: 14px">
                                                Rentang Tanggal
                                            </div>
                                            <div>
                                                <v-select
                                                    outlined
                                                    placeholder="Pilih Rentang Tanggal"
                                                    v-model="filter_type"
                                                    class="pa-0"
                                                    :items="[
                                                        {
                                                            text: 'Semua',
                                                            value: 'ALL',
                                                        },
                                                        {
                                                            text: 'Custom',
                                                            value: 'CUSTOM',
                                                        },
                                                    ]"
                                                ></v-select>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="filter_type === 'CUSTOM'">
                                        <v-col cols="12" md="12">
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <div
                                                        style="font-size: 14px"
                                                    >
                                                        Dari Tanggal
                                                    </div>
                                                    <div>
                                                        <v-dialog
                                                            ref="dialog"
                                                            v-model="modal_date"
                                                            :return-value.sync="
                                                                date
                                                            "
                                                            persistent
                                                            width="290px"
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    v-model="
                                                                        date
                                                                    "
                                                                    outlined
                                                                    dense
                                                                    readonly
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="date"
                                                                scrollable
                                                            >
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        modal_date = false
                                                                    "
                                                                >
                                                                    Cancel
                                                                </v-btn>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        $refs.dialog.save(
                                                                            date,
                                                                        )
                                                                    "
                                                                >
                                                                    OK
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-dialog>
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <div
                                                        style="font-size: 14px"
                                                    >
                                                        Sampai Tanggal
                                                    </div>
                                                    <div>
                                                        <v-dialog
                                                            ref="dialog2"
                                                            v-model="
                                                                modal_date2
                                                            "
                                                            :return-value.sync="
                                                                date2
                                                            "
                                                            persistent
                                                            width="290px"
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    v-model="
                                                                        date2
                                                                    "
                                                                    outlined
                                                                    dense
                                                                    readonly
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="date2"
                                                                scrollable
                                                            >
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        modal_date2 = false
                                                                    "
                                                                >
                                                                    Cancel
                                                                </v-btn>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        $refs.dialog2.save(
                                                                            date2,
                                                                        )
                                                                    "
                                                                >
                                                                    OK
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-dialog>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-card-actions class="pb-5 pr-3">
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        rounded
                                        depressed
                                        @click="menu = false"
                                    >
                                        Batal
                                    </v-btn>
                                    <v-btn
                                        rounded
                                        depressed
                                        color="primary"
                                        @click="doFilter()"
                                    >
                                        Terapkan
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>
                    </div>
                </v-cols>
            </v-row>
        </div>

        <v-card>
            <v-card-title> Daftar Konsul </v-card-title>

            <v-divider />

            <app-datatable
                :items="consul"
                :headers="headers"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :custom-pagination-total-items="total_data"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                :row-expanded-detail="rowDetail"
                :customWidth="true"
                :expanded.sync="expandedRows"
                :routeMenu="'konsul'"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editliveClass()"
                v-on:deleted="
                    dialogConfirm.function = $event;
                    dialogConfirm.title =
                        'Apakah anda yakin akan menghapus Live Class ini?';
                    dialogConfirm.open = true;
                "
                v-on:doSearch="
                    search = { query: $event.value, by: $event.key.value };
                    doSearch();
                "
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:openNewTab="openNewTab($event)"
                show-expand
                v-on:loadDetailExpanded="loadDetailExpanded($event)"
            >
            </app-datatable>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogConfirm.open = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            deleteliveClass(dialogConfirm.function);
                            dialogConfirm.open = false;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTableDropdown from "@/modules/global/components/plugins/DataTableDropdown";
import KonsulServices from "@/modules/konsul/services/konsul.js";
import Moment from "moment";
import axios from "axios";

export default {
    name: "live-class",

    components: {
        "app-datatable": DataTableDropdown,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            expandedRows: [],
            selectedRow: null,
            isLoading: false,
            headers: [
                { text: "Student", value: "student", width: "130" },
                { text: "Teacher", value: "teacher", width: "130" },
                { text: "Mata Pelajaran", value: "subject", width: "120" },
                { text: "Status", value: "status", width: "100" },
                { text: "Tanggal", value: "date", width: "120" },
                { text: "Jumlah Sesi", value: "session", width: "120" },
                { text: "Rating", value: "rating", width: "100" },
                { text: "Aksi", value: "data-table-expand" },
            ],
            headersKey: [
                "student",
                "teacher",
                "subject",
                "status",
                "date",
                "session",
                "rating",
            ],
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            search: "",
            tableKey: "",
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            consul: [],
            filters: [],
            total_data: 0,
            total_data_per_page: 10,
            total_pages: 0,
            params: {
                sortMode: "desc",
                student_email: "",
                student_id: null,
                grade: null,
                teacher_name: "",
                teacher_id: 0,
                subject_name: "",
                rating: null,
                status: null,
                date: null,
                total_session: null,
                start_date: null,
                end_date: null,
            },
            menu: false,
            filter_type: "ALL",
            modal_date: false,
            modal_date2: false,
            date: "",
            date2: "",
            rowDetail: null,
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        search() {
            this.fetchData();
        },
        pagination() {
            this.params.sortMode = this.pagination.sortMode;
            this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;
            this.isLoading = true;

            this.params.page = context.pagination.currentPage;
            this.params.per_page = context.pagination.perPage;

            KonsulServices.getListConsultation(this.params, (result) => {
                context.consul = [];
                context.total_data = result.data.total_item;
                context.pagination.totalPages = result.data.max_page;
                if (result.success) {
                    if (result.data.list_report !== null) {
                        result.data.list_report.forEach(function (data, index) {
                            if (data.date != null) {
                                data.date = Moment(data.date).format(
                                    "DD MMMM YYYY",
                                );
                            }
                            var row = {
                                no: index,
                                id: data.id,
                                student: data.student_email,
                                teacher: data.teacher_name,
                                subject: data.subject_name,
                                status: data.status,
                                date: data.date,
                                session: data.total_session,
                                rating: data.rating,
                            };
                            context.consul.push(row);
                            context.isLoading = false;
                        });
                    } else {
                        context.isLoading = false;
                    }
                } else {
                    alert("Terjadi kesalahan : " + result.message);
                    context.isLoading = false;
                }
                context.isLoading = false;
            });
        },

        doFilter() {
            var context = this;
            this.menu = false;

            if (this.filter_type === "ALL") {
                context.date = null;
                context.date2 = null;

                context.params.start_date = context.date;
                context.params.end_date = context.date2;
            } else {
                context.params.start_date = Moment(context.date).format(
                    "YYYY-MM-DD",
                );
                context.params.end_date = Moment(context.date2).format(
                    "YYYY-MM-DD",
                );
            }

            context.fetchData();
        },
        doSearch() {
            this.params.page = 1;
            this.pagination.currentPage = 1;

            if (!this.search.by || !this.search.query) {
                this.clearFilter();
            } else {
                this.params[this.search.by] = this.search.query;
            }

            if (this.search.by === "teacher") {
                this.params.teacher_name = this.search.query;
            } else if (this.search.by === "subject") {
                this.params.subject_name = this.search.query;
            } else if (this.search.by === "session") {
                this.params.total_session = this.search.query;
            } else if (this.search.by === "date") {
                this.params.date = Moment(this.search.query).format(
                    "YYYY-MM-DD",
                );
                this.params.start_date = this.params.date;
                this.params.end_date = this.params.date;
            }

            this.fetchData();
        },

        delByOneFilter(filter) {
            this.clearFilter();
            filter.value = "";
            var index = this.filters.push(filter) - 1;
            this.fetchData();
            this.filters.splice(index, 1);
        },

        clearFilter() {
            this.params = {
                page: 1,
                per_page: this.pagination.perPage,
                name: "",
                description: "",
                sort: "",
                subject: "",
                jenjang: "",
                grades: "",
            };
        },

        loadDetailExpanded(row) {
            this.rowDetail = null;
            const url = `${process.env.API_BASE_URL}konsul/admin/${row.item.id}/konsul`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.rowDetail = response.data;
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// Konsul.vue?61fb1ca3